module.exports = __webpack_public_path__ + "static/media/bkg04d.05ce0fd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/bkg04d.jpg
// module id = 469
// module chunks = 0